<template>
  <div>
    <app-cells><h1 class="title">Safari reservations</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'SafariReservationsListLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-safari-list', label: 'Requests' },
        { name: 'reservation-safari-confirmed', label: 'Confirmed' }
      ],
    }
  },
}
</script>
